<template>
	<div class="survey-progress" :class="{'has-shadow': hasShadow}">
		<div
			class="bar"
			:class="{'full': percent === 100}"
			ref="bar"
			:style="{
				width: `${percent}%`
			}"
		/>
	</div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-facing-decorator';

@Component
export default class SurveyProgress extends Vue {
	@Prop({ required: true })
	total: number;

	@Prop({ required: true })
	progress: number;

	hasShadow: boolean = false;

	mounted(): void {
		window.addEventListener('scroll', this.windowScrolled);
	}

	unmounted(): void {
		window.removeEventListener('scroll', this.windowScrolled);
	}

	windowScrolled(event: Event) {
		this.hasShadow = !!(window.scrollY > 10);
	}

	get percent(): number {
		if (this.total <= 0) {
			return 0;
		}

		return Math.min(100, Math.round((this.progress/this.total)*100));
	}

	@Watch('total', { immediate: true })
	watchTotal(newTotal: number): void {
		if (newTotal <= 0) {
			console.warn('Received 0 or negative total for progress');
		}
	}
}
</script>

<style lang="scss">
.survey-progress {
	@apply bg-fill-gray;

	min-height: 4px;
	max-height: 4px;
	width: 100vw;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 9999;

	/*box-shadow: 0 1px 2px rgba(0,0,0,0.15);*/

	/*&::after {
		box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.2);
		opacity: 0;
		transition: opacity 800ms ease-in-out;
	}

	&.has-shadow {
		&::after {
			opacity: 1;
		}
	}*/

	.bar {
		@apply relative bg-fill-accent;

		transition: width 600ms ease-in-out;

		&:not(.full) {
			/*border-radius: 0 5px 5px 0;*/
		}

		top: 0;
		left: 0;
		min-height: 4px;
		max-height: 4px;

		width: 0%;
	}
}
</style>
